<template>
  <nav class="service-list">
    <h2 class="service-list-heading">Our Service Packages</h2>
    <ul class="menu-list">
      <li v-for="(item, index) in menuItems" :key="index" class="menu-item">
        <router-link
          :to="item.path"
          class="menu-link"
          :class="{ active: currentPath === item.path }"
          @click="scrollToTop"
        >
          <span class="menu-text">{{ item.title }}</span>
          <v-icon
            class="chevron-icon"
            v-if="currentPath === item.path"
            icon="mdi-chevron-right"
          />
        </router-link>
        <span class="underline"></span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'MobileServicePackagesList',
  data() {
    return {
      menuItems: [
        { title: 'Custom Web & Mobile UX/UI Design', path: '/service-packages/custom-web-mobile-ux-ui-design' },
        { title: 'Business Website Package', path: '/service-packages/business-website-package' },
        { title: 'Marketing Website Package', path: '/service-packages/marketing-website-package' },
        { title: 'Portfolio Website Package', path: '/service-packages/portfolio-website-package' },
        { title: 'Shopify Store Development Package', path: '/service-packages/shopify-store-development' },
        { title: 'Shopify Migration Package', path: '/service-packages/shopify-migration' },
        { title: 'Custom E–Commerce Website Development', path: '/service-packages/custom-ecommerce-development' },
        { title: 'Stripe & Payment Integration', path: '/service-packages/stripe-and-payment-integration' },
        { title: 'API & 3rd–Party Tool Integrations', path: '/service-packages/api-and-3p-integrations' },
        { title: 'AI Code Review & Hardening', path: '/service-packages/ai-code-review-hardening' },
        { title: 'PWA Conversion (Basic)', path: '/service-packages/pwa-conversion-basic' },
        { title: 'PWA Conversion with Database', path: '/service-packages/pwa-conversion-with-database' },
      ],
    };
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
/* Hidden on screens > 768px (desktop/tablet landscape) */
.service-list { display: none; }

/* Visible on mobile (≤ 768px) */
@media (max-width: 768px) {
  .service-list {
    display: block;
    margin-top: 2rem;
    width: 100%;
    padding: 16px;
    font-family: Arial, sans-serif;
    text-align: center;
    border-top: 1px solid #e5e7eb;
    background: #fff;
  }
}

.service-list-heading {
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 16px;
}

.menu-list { list-style: none; padding: 0; margin: 0; }
.menu-item { position: relative; }
.menu-text { font-size: 1.2rem; padding: 0.5rem; }

.menu-link {
  display: flex; justify-content: space-between; align-items: center;
  padding: 15px 0; font-size: 0.9375rem; color: #4b5563; text-decoration: none;
  transition: color 0.3s ease; position: relative;
}

/* Dotted underline by default */
.menu-link::after {
  content: ''; position: absolute; bottom: 0; left: 0; width: 100%; height: 2px;
  background: linear-gradient(to right, #d1d5db 50%, transparent 50%); background-size: 8px 2px;
}

/* Blue animated overlay */
.menu-link::before {
  content: ''; position: absolute; bottom: 0; left: 0; width: 0; height: 2px;
  background-color: #00aeff; transition: width 0.5s ease; visibility: hidden;
}

/* Interactions */
.menu-link:hover::before { visibility: visible; width: 100%; }
.menu-link.active::before { visibility: visible; width: 100%; }
.menu-link.active::after, .menu-link:hover::after { visibility: hidden; }

.chevron-icon { font-size: 2rem; color: #00aeff; }

/* Tweak for very small screens */
@media (max-width: 580px) {
  .service-list { text-align: left; }
  .menu-text { font-size: 1rem; }
  .menu-link { padding: 10px 0; font-size: 0.875rem; }
  .chevron-icon { font-size: 1.5rem; }
}
</style>
